import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.datepicker";
import "@progress/kendo-ui/js/cultures/kendo.culture.en-US";
import "../../../kendo-ui-license";

// jQuery(document).ready(function () {
//   kendo.culture("en-US");

//   var checkInDatePicker = jQuery("#check-in-input")
//     .kendoDatePicker({
//       format: "yyyy-MM-dd",
//       min: new Date(),
//       componentType: "modern",
//       change: function () {
//         var checkInDate = this.value();
//         if (checkInDate) {
//           checkOutDatePicker.max(new Date(checkInDate.getTime() - 1));
//         }
//       },
//     })
//     .data("kendoDatePicker");

//   var checkOutDatePicker = jQuery("#check-out-input")
//     .kendoDatePicker({
//       format: "yyyy-MM-dd",
//       componentType: "modern",
//       change: function () {
//         var checkOutDate = this.value();
//         if (checkOutDate) {
//           checkInDatePicker.max(new Date(checkOutDate.getTime() - 1));
//         }
//       },
//     })
//     .data("kendoDatePicker");

//   checkInDatePicker.min(new Date());
// });
